import { render, staticRenderFns } from "./CalendarDetail.vue?vue&type=template&id=e81b86bc&"
import script from "./CalendarDetail.vue?vue&type=script&lang=js&"
export * from "./CalendarDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports